export default {
    actionIcon: 'StarIcon',
    highlightColor: 'warning',
    data: [
        // DASHBOARDS
        { index: 0, label: 'Dashboard', url: '/dashboard', labelIcon: 'HomeIcon', highlightAction: true },
    ],
}